"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSystemUser = void 0;
var SYSTEM_USER_PREFIX = 'sys_';
var isSystemUser = exports.isSystemUser = function isSystemUser(username) {
  return username && username.startsWith(SYSTEM_USER_PREFIX);
};